// extracted by mini-css-extract-plugin
module.exports = {"contents":"Contents_contents__2XCmr","cards":"Contents_cards__39A6p","loading":"Contents_loading__13ZGF","card":"Contents_card__AKKPY","no-data":"Contents_no-data__3Z8kW"};